import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-dev-to',
  templateUrl: './icon-dev-to.component.html',
  styleUrl: './icon-dev-to.component.scss',
  standalone: false
})
export class IconDevToComponent {
  @Input() tooltip?: string;
}
